export const PATHS = {
  ERROR: "/404/",
  MAINTENANCE: "/maintenance/",
  VIEWING_RESTRICTIONS_ERROR: "/viewing-restrictions/",
  MY_BOOKMARK: "/my/bookmark/",
  MY_HISTORY: "/my/history/",
  MY_LIBRARY: "/my/library/",
  NOTIFICATIONS: "/notifications/",
  PROFILE_CREATE: "/my/profile/create/",
  PROFILE_EDIT: "/my/profile/edit/",
  PROFILE: "/my/profile/",
  VOD: "/vod/",
  VOD_GRAVURE: "/vod/restrict/",
  VOD_RANKING: "/vod/ranking/",
  VOD_GRAVURE_RANKING: "/vod/restrict/ranking/",
  VOD_DETAIL: "/vod/detail/",
  VOD_GRAVURE_DETAIL: "/vod/restrict/detail/",
  VOD_LIST: "/vod/list/",
  VOD_GRAVURE_LIST: "/vod/restrict/list/",
  VOD_PLAYER: "/vod/playback/",
  VOD_FEATURE: "/vod/feature/",
  SEARCH: "/search/",
  COPYRIGHT: "/copyright/",
} as const;

export const EXTERNAL_PATHS = {
  REGISTRATION: "https://my.dmm.com/premium/?path=",
  WELCOME: "https://www.dmm.com/pr/premium/welcome/?backurl=",
  BENEFIT: "https://premium.dmm.com/benefit/",
};

export type PathsMap = typeof PATHS;

export type Paths = PathsMap[keyof PathsMap];
